export default __webpack_public_path__ + "static/media/img_5.8629f7cf.JPG";